if (!customElements.get('isla-free-shipping-bar')) {
  customElements.define(
    'isla-free-shipping-bar',
    class IslaFreeShippingBar extends HTMLElement {
      constructor() {
        super();
        this.thresholdCents = parseInt(this.dataset.thresholdCents, 10);
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      onCartUpdate() {
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then((response) => response.json())
          .then((cart) => this.render(cart.total_price))
          .catch(() => {});
      }

      formatEuro(cents) {
        return `€${(cents / 100).toFixed(2).replace('.', ',')}`;
      }

      render(totalPriceCents) {
        if (!this.thresholdCents) return;
        const remaining = Math.max(this.thresholdCents - totalPriceCents, 0);
        const percent = Math.min((totalPriceCents / this.thresholdCents) * 100, 100);
        const fill = this.querySelector('.isla-free-shipping-bar__fill');
        const message = this.querySelector('.isla-free-shipping-bar__message');

        if (fill) fill.style.width = `${percent}%`;
        if (message) {
          message.innerHTML =
            remaining === 0
              ? 'Je hebt gratis verzending!'
              : `Nog <strong>${this.formatEuro(remaining)}</strong> tot gratis verzending`;
        }
      }
    }
  );
}
